export const getLanguageOptions = () => {
  return {
    ab: { label: "Abkhazian", value: "ab" },
    aa: { label: "Afar", value: "aa" },
    af: { label: "Afrikaans", value: "af" },
    ak: { label: "Akan", value: "ak" },
    sq: { label: "Albanian", value: "sq" },
    am: { label: "Amharic", value: "am" },
    ar: { label: "Arabic", value: "ar" },
    an: { label: "Aragonese", value: "an" },
    hy: { label: "Armenian", value: "hy" },
    as: { label: "Assamese", value: "as" },
    av: { label: "Avaric", value: "av" },
    ae: { label: "Avestan", value: "ae" },
    ay: { label: "Aymara", value: "ay" },
    az: { label: "Azerbaijani", value: "az" },
    bm: { label: "Bambara", value: "bm" },
    ba: { label: "Bashkir", value: "ba" },
    eu: { label: "Basque", value: "eu" },
    be: { label: "Belarusian", value: "be" },
    bn: { label: "Bengali (Bangla)", value: "bn" },
    bh: { label: "Bihari", value: "bh" },
    bi: { label: "Bislama", value: "bi" },
    bs: { label: "Bosnian", value: "bs" },
    br: { label: "Breton", value: "br" },
    bg: { label: "Bulgarian", value: "bg" },
    my: { label: "Burmese", value: "my" },
    ca: { label: "Catalan", value: "ca" },
    ch: { label: "Chamorro", value: "ch" },
    ce: { label: "Chechen", value: "ce" },
    ny: { label: "Chichewa, Chewa, Nyanja", value: "ny" },
    zh: { label: "Chinese", value: "zh" },
    "zh-Hant": { label: "Chinese (Traditional)", value: "zh-Hant" },
    cv: { label: "Chuvash", value: "cv" },
    kw: { label: "Cornish", value: "kw" },
    co: { label: "Corsican", value: "co" },
    cr: { label: "Cree", value: "cr" },
    hr: { label: "Croatian", value: "hr" },
    cs: { label: "Czech", value: "cs" },
    da: { label: "Danish", value: "da" },
    dv: { label: "Divehi, Dhivehi, Maldivian", value: "dv" },
    nl: { label: "Dutch", value: "nl" },
    dz: { label: "Dzongkha", value: "dz" },
    en: { label: "English", value: "en" },
    eo: { label: "Esperanto", value: "eo" },
    et: { label: "Estonian", value: "et" },
    ee: { label: "Ewe", value: "ee" },
    fo: { label: "Faroese", value: "fo" },
    fj: { label: "Fijian", value: "fj" },
    fi: { label: "Finnish", value: "fi" },
    fr: { label: "French", value: "fr" },
    ff: { label: "Fula, Fulah, Pulaar, Pular", value: "ff" },
    gl: { label: "Galician", value: "gl" },
    gd: { label: "Gaelic (Scottish)", value: "gd" },
    gv: { label: "Gaelic (Manx)", value: "gv" },
    ka: { label: "Georgian", value: "ka" },
    de: { label: "German", value: "de" },
    el: { label: "Greek", value: "el" },
    kl: { label: "Greenlandic", value: "kl" },
    gn: { label: "Guarani", value: "gn" },
    gu: { label: "Gujarati", value: "gu" },
    ht: { label: "Haitian Creole", value: "ht" },
    ha: { label: "Hausa", value: "ha" },
    he: { label: "Hebrew", value: "he" },
    hz: { label: "Herero", value: "hz" },
    hi: { label: "Hindi", value: "hi" },
    ho: { label: "Hiri Motu", value: "ho" },
    hu: { label: "Hungarian", value: "hu" },
    is: { label: "Icelandic", value: "is" },
    io: { label: "Ido", value: "io" },
    ig: { label: "Igbo", value: "ig" },
    id: { label: "Indonesian", value: "id" },
    ia: { label: "Interlingua", value: "ia" },
    ie: { label: "Interlingue", value: "ie" },
    iu: { label: "Inuktitut", value: "iu" },
    ik: { label: "Inupiak", value: "ik" },
    ga: { label: "Irish", value: "ga" },
    it: { label: "Italian", value: "it" },
    ja: { label: "Japanese", value: "ja" },
    jv: { label: "Javanese", value: "jv" },
    kn: { label: "Kannada", value: "kn" },
    kr: { label: "Kanuri", value: "kr" },
    ks: { label: "Kashmiri", value: "ks" },
    kk: { label: "Kazakh", value: "kk" },
    km: { label: "Khmer", value: "km" },
    ki: { label: "Kikuyu", value: "ki" },
    rw: { label: "Kinyarwanda (Rwanda)", value: "rw" },
    rn: { label: "Kirundi", value: "rn" },
    ky: { label: "Kyrgyz", value: "ky" },
    kv: { label: "Komi", value: "kv" },
    kg: { label: "Kongo", value: "kg" },
    ko: { label: "Korean", value: "ko" },
    ku: { label: "Kurdish", value: "ku" },
    kj: { label: "Kwanyama", value: "kj" },
    lo: { label: "Lao", value: "lo" },
    la: { label: "Latin", value: "la" },
    lv: { label: "Latvian (Lettish)", value: "lv" },
    li: { label: "Limburgish ( Limburger)", value: "li" },
    ln: { label: "Lingala", value: "ln" },
    lt: { label: "Lithuanian", value: "lt" },
    lu: { label: "Luga-Katanga", value: "lu" },
    lg: { label: "Luganda, Ganda", value: "lg" },
    lb: { label: "Luxembourgish", value: "lb" },
    mk: { label: "Macedonian", value: "mk" },
    mg: { label: "Malagasy", value: "mg" },
    ms: { label: "Malay", value: "ms" },
    ml: { label: "Malayalam", value: "ml" },
    mt: { label: "Maltese", value: "mt" },
    mi: { label: "Maori", value: "mi" },
    mr: { label: "Marathi", value: "mr" },
    mh: { label: "Marshallese", value: "mh" },
    mo: { label: "Moldavian", value: "mo" },
    mn: { label: "Mongolian", value: "mn" },
    na: { label: "Nauru", value: "na" },
    nv: { label: "Navajo", value: "nv" },
    ng: { label: "Ndonga", value: "ng" },
    nd: { label: "Northern Ndebele", value: "nd" },
    ne: { label: "Nepali", value: "ne" },
    no: { label: "Norwegian", value: "no" },
    nb: { label: "Norwegian bokmål", value: "nb" },
    nn: { label: "Norwegian nynorsk", value: "nn" },
    ii: { label: "Nuosu", value: "ii" },
    oc: { label: "Occitan", value: "oc" },
    oj: { label: "Ojibwe", value: "oj" },
    cu: { label: "Old Church Slavonic, Old Bulgarian", value: "cu" },
    or: { label: "Oriya", value: "or" },
    om: { label: "Oromo (Afaan Oromo)", value: "om" },
    os: { label: "Ossetian", value: "os" },
    pi: { label: "Pāli", value: "pi" },
    ps: { label: "Pashto, Pushto", value: "ps" },
    fa: { label: "Persian (Farsi)", value: "fa" },
    pl: { label: "Polish", value: "pl" },
    pt: { label: "Portuguese", value: "pt" },
    pa: { label: "Punjabi (Eastern)", value: "pa" },
    qu: { label: "Quechua", value: "qu" },
    rm: { label: "Romansh", value: "rm" },
    ro: { label: "Romanian", value: "ro" },
    ru: { label: "Russian", value: "ru" },
    se: { label: "Sami", value: "se" },
    sm: { label: "Samoan", value: "sm" },
    sg: { label: "Sango", value: "sg" },
    sa: { label: "Sanskrit", value: "sa" },
    sr: { label: "Serbian", value: "sr" },
    sh: { label: "Serbo-Croatian", value: "sh" },
    st: { label: "Sesotho", value: "st" },
    tn: { label: "Setswana", value: "tn" },
    sn: { label: "Shona", value: "sn" },
    sd: { label: "Sindhi", value: "sd" },
    si: { label: "Sinhalese", value: "si" },
    ss: { label: "Siswati", value: "ss" },
    sk: { label: "Slovak", value: "sk" },
    sl: { label: "Slovenian", value: "sl" },
    so: { label: "Somali", value: "so" },
    nr: { label: "Southern Ndebele", value: "nr" },
    es: { label: "Spanish", value: "es" },
    su: { label: "Sundanese", value: "su" },
    sw: { label: "Swahili (Kiswahili)", value: "sw" },
    sv: { label: "Swedish", value: "sv" },
    tl: { label: "Tagalog", value: "tl" },
    ty: { label: "Tahitian", value: "ty" },
    tg: { label: "Tajik", value: "tg" },
    ta: { label: "Tamil", value: "ta" },
    tt: { label: "Tatar", value: "tt" },
    te: { label: "Telugu", value: "te" },
    th: { label: "Thai", value: "th" },
    bo: { label: "Tibetan", value: "bo" },
    ti: { label: "Tigrinya", value: "ti" },
    to: { label: "Tonga", value: "to" },
    ts: { label: "Tsonga", value: "ts" },
    tr: { label: "Turkish", value: "tr" },
    tk: { label: "Turkmen", value: "tk" },
    tw: { label: "Twi", value: "tw" },
    ug: { label: "Uyghur", value: "ug" },
    uk: { label: "Ukrainian", value: "uk" },
    ur: { label: "Urdu", value: "ur" },
    uz: { label: "Uzbek", value: "uz" },
    ve: { label: "Venda", value: "ve" },
    vi: { label: "Vietnamese", value: "vi" },
    vo: { label: "Volapük", value: "vo" },
    wa: { label: "Wallon", value: "wa" },
    cy: { label: "Welsh", value: "cy" },
    wo: { label: "Wolof", value: "wo" },
    fy: { label: "Western Frisian", value: "fy" },
    xh: { label: "Xhosa", value: "xh" },
    yi: { label: "Yiddish", value: "yi" },
    yo: { label: "Yoruba", value: "yo" },
    za: { label: "Zhuang, Chuang", value: "za" },
    zu: { label: "Zulu", value: "zu" },
  };
};
